import { logCoreUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import { getSeedStatus } from 'owa-copilot-async-chat';
import getEntriesBySection from '../selectors/getEntriesBySection';
import { getTasksHubStatusSummary } from '../selectors/getTasksHubStatusSummary';
import { TasksHubSection } from './TasksHubSection';

export type TasksHubViewSource = 'drawerHeaderMenu' | 'dabViewAll';

/**
 * Logs the backlog state the user lands on when the Tasks Hub is opened.
 */
export function logTasksHubViewed(mailboxInfo: MailboxInfo, source: TasksHubViewSource): void {
    const sections = getEntriesBySection(mailboxInfo);
    const needsYourInputCount = sections[TasksHubSection.NeedsYourInput].length;
    const inProgressCount = sections[TasksHubSection.InProgress].length;
    const { count, mostUrgentState } = getTasksHubStatusSummary(mailboxInfo);
    logCoreUsage('AsyncChat_TasksHubViewed', mailboxInfo, {
        source,
        needsYourInputCount,
        inProgressCount,
        total: count,
        mostUrgentState: mostUrgentState ?? 'none',
        seedStatus: getSeedStatus(mailboxInfo),
    });
}
